























import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'

@Component({
  components: {
    Modal
  }
})
export default class EditYourselfPopup extends Vue {}
